/* eslint-disable global-require */
export default {
    default: {
        '@spp/ui-core-navigation': require('@vg/cn-skin-vg/styles/components/CoreNavigation.scss'),
        '@spp/cn-login-button': require('@vg/cn-skin-vg/styles/components/LoginButton.scss'),
        '@spp/cn-subscribe-button': require('@vg/cn-skin-vg/styles/components/SubscribeButton.scss'),
        '@spp/cn-chevron-down-main-menu': require('@spp/cn-skin-core/styles/svg/Chevron.scss'),
        '@spp/cn-chevron-down-masthead-extension': require('@spp/cn-skin-core/styles/svg/Chevron.scss'),
        '@spp/cn-chevron-left': require('@spp/cn-skin-core/styles/svg/ChevronLeft.scss'),
        '@spp/cn-logo': require('@vg/cn-skin-vg/styles/svg/Logo.scss'),
        '@spp/cn-main-menu': require('@vg/cn-skin-vg/styles/components/MainMenu.scss'),
        '@spp/cn-masthead': require('../../themes/Masthead.scss'),
        '@spp/cn-masthead-extension': require('../../themes/MastheadExtension.scss'),
        '@spp/cn-masthead-extension-basic-view': require('@vg/cn-skin-vg/styles/components/MastheadExtensionBasicView.scss'),
        '@spp/cn-masthead-extension-section-view': require('@vg/cn-skin-vg/styles/components/MastheadExtensionSectionView.scss'),
        '@spp/cn-masthead-search': require('@spp/cn-skin-core/styles/svg/MastheadSearch.scss'),
        '@spp/cn-search': require('@vg/cn-skin-vg/styles/components/Search.scss'),
        '@spp/cn-sitemap': require('@vg/cn-skin-vg/styles/components/SiteMap.scss'),
        '@spp/cn-user-menu': require('@vg/cn-skin-vg/styles/components/UserMenu.scss'),
        '@spp/cn-masthead-extension-subscription-buttons': require('@vg/cn-skin-vg/styles/components/MastheadExtensionSubscriptionButtons.scss'),
        '@spp/cn-masthead-extension-widgets': require('@vg/cn-skin-vg/styles/components/MastheadExtensionWidgets.scss'),
        '@spp/cn-user-logged-in-button': require('@spp/cn-skin-core/styles/svg/UserLoggedInButton.scss'),
        '@spp/cn-logged-in-badge': require('@vg/cn-skin-vg/styles/components/LoggedInBadge.scss'),
    },
};



/** WEBPACK FOOTER **
 ** ./src/theme/index.js
 **/